<template>
  <cube-scroll
    ref="scrollRef"
    :options="scrollOptions"
    @pulling-down="onPullingDown"
    @pulling-up="onPullingUp"
  >
    <section v-if="courseList.length > 0">
      <course-list :courses="courseList"></course-list>
    </section>
    <div v-else style="padding-top: 20px">
      暂无课程
    </div>
  </cube-scroll>
</template>

<script>
import CourseList from '@/components/CourseList'
import { queryCourseList } from '@/api/course'

export default {
  name: 'CourseListPanel',
  components: {
    CourseList
  },
  props: {
    typeCode: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      scrollOptions: {
        pullDownRefresh: {
          txt: '刷新成功'
        },
        pullUpLoad: {
          txt: {
            more: '加载更多',
            noMore: '到底啦~'
          }
        }
      },
      courseList: [],
      isFirst: true,
      curPage: 1,
      total: 0
    }
  },
  methods: {
    onPullingDown () {
      // 模拟更新数据
      this.curPage = 1
      this.courseList.splice(0)
      this.getCourseData()

      setTimeout(() => {
        this.$refs.scrollRef.forceUpdate()
      }, 1000)
    },
    onPullingUp () {
      // 模拟更新数据
      if (this.courseList.length >= this.total) {
        this.$refs.scrollRef.forceUpdate()
        return
      }
      this.curPage += 1
      this.getCourseData()
      setTimeout(() => {
        this.$refs.scrollRef.forceUpdate()
      }, 1000)
    },

    getCourseData () {
      queryCourseList({
        typeCode: this.typeCode,
        page: this.curPage,
        size: 1000
      })
        .then((res) => {
          this.total = res.data.total
          const records = res.data.records
          // fixme 排序
          records.sort(this.compare('sort'))
          records.forEach((item, idx) => {
            this.courseList.push({
              id: item.courseId,
              title: item.name,
              url: item.cover.resUrl,
              read: item.readNum,
              comment: item.commentNum,
              type: this.typeCode,
              medias: item.medias
            })
          })
        })
    },

    compare (attr) {
      return function (a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val1 - val2
      }
    }
  },
  mounted () {
    if (this.isFirst) {
      this.isFirst = false
      this.getCourseData()
    }
  }
}
</script>

<style lang="stylus" scoped>
section
  background-color #fff
  padding 0 15px
  margin-top 10px
</style>
